import { Briefcase, Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatBp, toBp } from './project-shares';
import type { Report } from './types';

/** The note's projects with their % and its client, under the status (U1 board 1.4). */
export function ReportParityHead({ report }: { readonly report: Report }) {
  const { t } = useTranslation('expenses-parity');
  const projects = report.projects ?? [];
  const client = report.client ?? null;
  if (projects.length === 0 && client === null) return null;
  return (
    <dl className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
      {projects.length > 0 ? (
        <div className="flex flex-wrap items-center gap-2">
          <dt className="text-muted-foreground">{t('projects.title')}</dt>
          {projects.map((project) => (
            <dd
              key={project.projectId}
              className="bg-muted inline-flex items-center gap-1 rounded-md px-2 py-0.5"
            >
              <Briefcase className="size-3.5" aria-hidden />
              {project.code} · {project.name} <b>{formatBp(toBp(project.percent) ?? 0)} %</b>
              {project.archived ? (
                <span className="text-muted-foreground">({t('head.archived')})</span>
              ) : null}
            </dd>
          ))}
        </div>
      ) : null}
      {client ? (
        <div className="flex flex-wrap items-center gap-2">
          <dt className="text-muted-foreground">{t('client.title')}</dt>
          <dd className="bg-muted inline-flex items-center gap-1 rounded-md px-2 py-0.5">
            <Building2 className="size-3.5" aria-hidden />
            {client.code} · {client.name}
            {client.archived ? (
              <span className="text-muted-foreground">({t('head.archived')})</span>
            ) : null}
          </dd>
        </div>
      ) : null}
    </dl>
  );
}
